const ACLPreferenceTypePolicy = {
  ACLPreference: {
    keyFields: ({ uid }) => uid,
  },
};

export default ACLPreferenceTypePolicy;
